import { useState, useEffect } from 'react';
import React, { useParams } from 'react-router-dom';
import axios from 'axios';
import translations from '../translations';

const EnableRSVP = () => {
  const { id } = useParams();
  const [isRsvpEnabled, setIsRsvpEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
        .then(response => {
          console.log(response.data.rsvp);
          const rsvpStatus = JSON.parse(response.data.rsvp);
          setIsRsvpEnabled(rsvpStatus);
          setEmailEnabled(response.data.email_input);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
  }, []);

  const toggleRsvp = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-rsvp/${id}`, { rsvp: !isRsvpEnabled })
      .then(response => {
          console.log(response.data.message); // Log success message
          setIsRsvpEnabled(!isRsvpEnabled);
          window.location.reload();
      })
      .catch(error => {
          console.error('Error updating rsvp:', error);
      });
  };
  const toggleEmail = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-emailinput/${id}`, { email_input: !emailEnabled })
      .then(response => {
          console.log(response.data.message); // Log success message
          setEmailEnabled(!emailEnabled);
          window.location.reload();
      })
      .catch(error => {
          console.error('Error updating rsvp:', error);
      });
  };

  return (
    <div>
      <div className="flex items-center my-5">
        <h1 className='text-black font-bold'>{t.activateRsvp}</h1>
        <input
          type="checkbox"
          checked={isRsvpEnabled}
          onChange={toggleRsvp}
          id="rsvpToggle"
          className="hidden"
        />
        <label
          htmlFor="rsvpToggle"
          className="flex items-center cursor-pointer bg-gray-100 w-14 h-7 rounded-full p-1 border border-gray-300 transition duration-300 ease-in-out ml-auto"
        >
          <div
            className={`${
              isRsvpEnabled ? 'translate-x-7 bg-green-500' : 'translate-x-0 bg-gray-400'
            } w-5 h-5 rounded-full shadow-md transform transition-transform`}
          ></div>
        </label>
      </div>
      <div className="flex items-center my-5">
        <h1 className='text-black font-bold'>{t.needGuestEmail}</h1>
        <input
          type="checkbox"
          checked={emailEnabled}
          onChange={toggleEmail}
          id="emailToggle"
          className="hidden"
        />
        <label
          htmlFor="emailToggle"
          className="flex items-center cursor-pointer bg-gray-100 w-14 h-7 rounded-full p-1 border border-gray-300 transition duration-300 ease-in-out ml-auto"
        >
          <div
            className={`${
              emailEnabled ? 'translate-x-7 bg-green-500' : 'translate-x-0 bg-gray-400'
            } w-5 h-5 rounded-full shadow-md transform transition-transform`}
          ></div>
        </label>
      </div>
    </div>

  );
};

export default EnableRSVP;
